export default __webpack_public_path__ + "static/generative-border-colors-light-080a0d913703cd32fb61fbef46a20e9b.png";